import { S3, Credentials } from "aws-sdk";
import { Auth } from "aws-amplify";
import { decorate, injectable } from "inversify";
import aws from "./aws-exports";
const bucket = "gamma-accountcentre";

export class FileSharingService {
  private s3: S3;

  constructor() {
    this.s3 = new S3();
    this.getCurrentCredentials().then((auth: Credentials) => this.setS3(auth));
  }

  setS3(auth: Credentials) {
    this.s3 = this.getS3(auth);
  }

  listFiles(directory: string): Promise<any> {
    return this.s3
      .listObjects({
        Bucket: bucket,
        Prefix: directory,
      })
      .promise();
  }

  downloadFile(fileName: string, directory: string): Promise<any> {
    return this.s3
      .getObject({
        Bucket: bucket,
        Key: directory + fileName,
      })
      .promise();
  }

  async uploadFile(fileName: string, file: Blob, directory: string) {
    return this.s3
      .putObject({
        Bucket: bucket,
        Key: directory + fileName,
        ContentType: file.type,
        Body: file,
      })
      .promise();
  }

  deleteFile(directory: string, fileName: string) {
    return this.s3
      .deleteObject({
        Bucket: bucket,
        Key: directory + fileName,
      })
      .promise();
  }

  // S3 and auth functions
  getCredentials(): Credentials {
    return new Credentials({
      accessKeyId: aws.S3.accessKeyId as string,
      secretAccessKey: aws.S3.secretAccessKey as string,
    });
  }

  getCurrentCredentials(): Promise<any> {
    return new Promise((resolve, reject) =>
      Auth.currentCredentials()
        .then((credentials: any) => {
          resolve(credentials);
        })
        .catch((err: any) => {
          reject(err);
        })
    );
  }

  getS3(credentials: any): S3 {
    return new S3({
      credentials,
      secretAccessKey: aws.S3.secretAccessKey,
      region: aws.S3.region,
    });
  }
}

decorate(injectable(), FileSharingService);
